import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <footer id="contact">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="footer_links">
              <h3>Contact</h3>
              <ul>
                <li style={{ display: "inline-block" }}>
                  <a href="tel:+971 54 888 5164">
                    <i className="fa fa-phone" aria-hidden="true"></i> +971 54
                    888 5164
                  </a>
                </li>
                <li style={{ display: "inline-block" }}>
                  <a
                    href="https://wa.me/971548885164?text=Hello%2C%20I%27m%20interested%20in%20your%20services.%20Could%20you%20please%20provide%20more%20information%3F"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-whatsapp" aria-hidden="true"></i>{" "}
                    WhatsApp Us
                  </a>
                </li>
                <li>
                  <a href="mailto:admin@velocitylimousinedubai.com">
                    <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                    admin@velocitylimousinedubai.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://goo.gl/maps/vR5BVxQpNJAeFkcXA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    <span>2908, Al Salam Tower, Dubai Media City</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                Copyright © 2023. Velocity Limousine LLC. All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
